import styled from "styled-components";

export const SProjectLimitModalPricingCardsWrapper = styled.div`
  padding: 20px;
`;
